import { useState } from 'react';
import { useAppCookies } from '@app/providers/AppCookieProvider';
import { ToLogout } from '@app/navigation/ToLogout';
import { useUserProfileViewCreator } from '@viewCreators/UserProfileViewCreator';

export const useApp = () => {
  const cookies = useAppCookies();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const userId = cookies.profile?.id ? Number(cookies.profile.id) : 0;
  const { data: user } = useUserProfileViewCreator(userId);

  const avatarUrl = user?.avatarUrl || cookies.profile?.picture || '';
  const displayName = user?.name || cookies.profile?.name || '';

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = (open: boolean) => {
    setMenuOpen(open);
  };

  return {
    cookies,
    anchorEl,
    menuOpen,
    avatarUrl,
    displayName,
    handleClose,
    logout: ToLogout,
    toggleDrawer,
  };
};
